import {ROOT_DIR} from "../App";
import {Helmet} from "react-helmet";
import React from "react";

function DefaultHelmet({
        title = "Agence Immobilière Monthey & Vevey | Vente et Location de Biens",
        description = "FOTI Immobilier, votre agence de confiance à Monthey et Vevey. Découvrez nos annonces de vente et de location d'appartements, maisons, commerces et plus encore. Contactez-nous pour vos projets immobiliers.",
        og_url = ROOT_DIR,
        og_description = "FOTI Immobilier : Trouvez votre bien idéal à Monthey et Vevey. Vente, location d'appartements, maisons, commerces. Contactez nos experts !",
        og_type = "website",
        image = ROOT_DIR + "/images/static/logo-foti-immobilier.jpg",
        locale = "ch_CH",
        sitename = "FOTI Immobilier"
}) {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description}/>
            <meta property="og:title" content={title}/>
            <meta property="og:description" content={og_description}/>
            <meta property="og:type" content={og_type}/>
            <meta property="og:url" content={og_url}/>
            <meta property="og:image" content={image}/>
            <meta property="og:site_name" content={sitename}/>
            <meta property="og:locale" content={locale}/>
            {/*<meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:site"
                      content="@VotreCompteTwitter"/>*/}
            <meta name="twitter:title" content={title}/>
            <meta name="twitter:description" content={og_description}/>
            <meta name="twitter:image" content={image}/>
            <link rel="image_src" href={image}/>
        </Helmet>
    );
}

export default DefaultHelmet;